import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import CategoryInfo from '../CategoryInfo';
import IconEnabled from 'core/components/layout/IconEnabled';
import MfproductListByCategory from 'components/category2product/components/MfproductListByCategory';
import Category2productList from '../../category2product/Category2productList';
import CheckIcon from '@mui/icons-material/Check';


export default function CategoryListTableRow({obj, getActionComponent,actionList,handleRowClick}){
  const {mobileView} = useSelector((state)=>state.menu);
  const {categoryObj} = useSelector((state)=>state.manufslice.categoryDashboard);
  const {category2productList}= useSelector((state)=>state.manufslice);
  useEffect(() => {
      console.log("category2productList is changed");
  }, [category2productList])

  useEffect(()=>{
  },[])
  
  const getHoverColor = () =>{
    if (mobileView) return ''
    return 'primary.main';
  }
  const getHoverBackgroundColor = () =>{
    if (mobileView) return ''
    return 'secondary.200';
  }
  const getBackgroundColor = (obj) =>{
    if (mobileView) {
      if (obj.expand) return 'secondary.500'
      return 'white'
    }
    return 'white'
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%', }}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  
              backgroundColor: getBackgroundColor(obj),
              color: mobileView && obj.expand?'primary.main':'primary.darker',
              '&:hover': {
                backgroundColor: getHoverBackgroundColor, 
                color: getHoverColor()
              },
            }}>
            {/* <ROW1 - CELLS/> */}
            
              <Grid item lg={6} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.title}</Typography></Grid>
              <Grid item lg={3} xs={3}>
                {obj.special ? (
                  <Box
                    sx={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 24,
                      height: 24,
                      borderRadius: '50%',
                      backgroundColor: 'primary.darker', // changed to primary.darker
                    }}
                  >
                    <CheckIcon sx={{ color: '#fff', fontSize: 18 }} /> {/* icon color white */}
                  </Box>
                ) : (
                  <Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>&nbsp;</Typography>
                )}
              </Grid>

              <Grid item lg={2} xs={3} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  {/* {getActionComponent(obj)} */}
                  <IconEnabled key={`${obj.id}-${actionList[0].title}`} actionObj={actionList[0]} id={obj.id} />
                  <IconEnabled key={`${obj.id}-${actionList[2].title}`} actionObj={actionList[2]} id={obj.id} />
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        <Grid item lg={12} sx={{ width: '100%' }}></Grid>
        {obj.expand?
        <Grid container direction="row" sx={{ width: '100%' }}>
          <Grid item sx={{ width: '100%' }}>
            < MfproductListByCategory  categoryId={obj.id} />
          </Grid>
          {/* <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid> */}
        </Grid>
         : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
        }
      </>
      
    )
}